import postalOperatorsMapper from '../mappers/postalOperatorsMapper';
import { RETRIEVE_OUTBOUND_POSTAL_OPERATOR_UNLOCODE_SUCCESS } from '../actions/types/DeparturePostalOperatorActionTypes';
import { LOGGED_OUT } from '../../../../../core/modules/security/redux/actions/types/SecurityActionTypes';

export const initialState = [];

export const outboundPostalOperatorReducer = (state = initialState, action) => {
  switch (action.type) {
    case RETRIEVE_OUTBOUND_POSTAL_OPERATOR_UNLOCODE_SUCCESS:
      return postalOperatorsMapper(action.payload);
    case LOGGED_OUT:
      return initialState;
    default:
      return state;
  }
};

